import React from "react";

const TextForm = ({value, handleOnChange}) => {
  return <input className="input" type="text" value={value} onChange={handleOnChange}></input>;
};

export default TextForm;
